export default __webpack_public_path__ + "static/media/cross.17d88569.svg";